const boxShadow = {
    extraSmall: '0px 0px 1px rgba(0, 0, 0, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.08);',
    small: '0px 0px 1px rgba(0, 0, 0, 0.08), 0px 3px 3px -1px rgba(0, 0, 0, 0.08)',
    medium: '0px 0px 1px rgba(0, 0, 0, 0.08), 0px 6px 6px -1px rgba(0, 0, 0, 0.08)',
    large: '0px 0px 1px rgba(0, 0, 0, 0.08), 0px 16px 16px -1px rgba(0, 0, 0, 0.08)',
    extraLarge: '0px 0px 1px rgba(0, 0, 0, 0.08), 0px 32px 40px -2px rgba(0, 0, 0, 0.08)',
};
export default boxShadow;
